import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/internal/Observable";
import { CommissionSettings, QuotationListRequestModel, QuotationResponseModel, UpdateQuotationModel, UpdateQuotationSpecialRequestModel, UpdateSelectedInsuranceModel } from "@model/quotation.model";
import { GenericApiResponseModel, ResponseModel } from "@model/api.model";

@Injectable({
    providedIn: "root",
})
export class QuotationApiService {

    constructor(
        private http: HttpClient) {
        
    }

    UpdatePayment(model: QuotationResponseModel): Observable<any> {
        return this.http.post<any>("/Quotation/UpdatePayment",model);
    }

    UpdateQuotation(model: UpdateQuotationModel): Observable<any> {
        return this.http.post<any>("/Quotation/UpdateQuotation",model);
    }

    UpdateSelectedInsurance(model: UpdateSelectedInsuranceModel): Observable<any> {
        return this.http.post<any>("/Quotation/UpdateSelectedInsurance",model);
    }

    UpdatePaymentLinkSentDateTime(referenceNumber: string): Observable<any> {
        return this.http.post<any>("/Quotation/UpdatePaymentLinkSentDateTime/"+referenceNumber,'');
    }

    getQuotationList(model: QuotationListRequestModel): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.post<ResponseModel<GenericApiResponseModel<any>>>(
            '/Quotation/List', model
        );
    }

    getInstantQuotation(referenceNumber: string): Observable<ResponseModel<GenericApiResponseModel<any>>> {
        return this.http.get<ResponseModel<GenericApiResponseModel<any>>>(
            '/Quotation/Instant/'+referenceNumber
        );
    }

    getExistingQuotation(referenceNumber: string): Observable<QuotationResponseModel> {
        return this.http.get<QuotationResponseModel>(
            '/Quotation/Existing/'+referenceNumber
        );
    }

    deleteQuotation(referenceNumber: string): Observable<any> {
        return this.http.post<ResponseModel<any>>(
            '/Quotation/DeleteQuotation?referenceNumber='+referenceNumber, ''
        );
    }

    removeAllInsurance(referenceNumber: string): Observable<any> {
        return this.http.post<ResponseModel<any>>(
            '/quotation/removeAllInsurance?referenceNumber='+referenceNumber, ''
        );
    }

    UpdateQuotationSpecialRequest(model: UpdateQuotationSpecialRequestModel): Observable<any> {
        return this.http.post<ResponseModel<any>>(
            '/Quotation/UpdateQuotationSpecialRequest', model
        );
    }

    commissionSettings(): Observable<ResponseModel<CommissionSettings>> {
        return this.http.get<ResponseModel<CommissionSettings>>(
            '/Quotation/commissionSettings/'
        );
    }
}
